// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverLay_overlay__ezgOl","loader":"LoadingOverLay_loader__SG7gy"};